import React from 'react';
export function TestimonialsSection() {
  return <section className="w-full bg-white py-20" data-id="element-1946">
      <div className="container mx-auto px-6" data-id="element-1947">
        <h2 className="text-3xl font-normal text-black mb-16" data-id="element-1948">
          Marcas que han confiado en mí
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1949">
          <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1950">
            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-1951">
              <span className="text-3xl text-black" data-id="element-1952">"</span> Llegué a la cuenta
              de Fran buscando ideas para mi próximo viaje, y terminé
              encontrando mucho más. Sus historias me hicieron detenerme, pensar
              y reconectar conmigo. Gracias a él me animé a hacer mi primer
              viaje sola, y no solo fue una aventura… fue el inicio de un cambio
              que llevaba tiempo necesitando.{' '}
              <span className="text-3xl text-black" data-id="element-1953">"</span>
            </p>
            <div data-id="element-1954">
              <p className="text-lg font-medium text-black" data-id="element-1955">Laura Méndez</p>
              <p className="text-sm text-gray-600" data-id="element-1956">Seguidora y viajera</p>
            </div>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1957">
            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-1958">
              <span className="text-3xl text-black" data-id="element-1959">"</span> Sigo a Fran porque
              no solo muestra lugares increíbles, también comparte lo que esos
              lugares le enseñan. Sus reflexiones me inspiran a salir, moverme y
              escucharme más. Después de ver uno de sus videos, decidí
              inscribirme en una caminata que me regaló una claridad que no
              sentía hace años. <span className="text-3xl text-black" data-id="element-1960">"</span>
            </p>
            <div data-id="element-1961">
              <p className="text-lg font-medium text-black" data-id="element-1962">Andrés Pérez</p>
              <p className="text-sm text-gray-600" data-id="element-1963">
                Seguidor y amante de la naturaleza
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}